import {
  ServerModel,
  EAttributeKind,
  ModelNode,
} from '~store/modules/model/types';

export const serializeModel = (
  nodes: ModelNode[],
  modelProps: Partial<{
    version: string;
    backgroundColor: string;
    backgroundImage: string;
    backgroundVariant: 'dotted' | 'grid' | 'none';
  }>,
): ServerModel => {
  return {
    toJSON: true,
    extraProperties: modelProps,
    dataClasses: nodes.map((node) => {
      return {
        ...node.data,
        extraProperties: {
          position: {
            x: node.position.x,
            y: node.position.y,
          },
          panelColor: node.data.extraProperties?.panelColor,
        },
      };
    }),
  };
};

export function getDefaultName(
  prefix: string,
  _propertyKey: string,
  items: Record<string, any>,
): string {
  const defaultID = prefix;
  let occurencies = 0;

  while (items[`${defaultID}${occurencies ? occurencies : ''}`]) {
    occurencies++;
  }
  return `${defaultID}${occurencies ? occurencies : ''}`;
}

export const isRelatedEntityAttr = (attribute: catalog.IAttribute) =>
  attribute.kind === EAttributeKind.RELATEDENTITY;
export const isRelatedEntitiesAttr = (attribute: catalog.IAttribute) =>
  attribute.kind === EAttributeKind.RELATEDENTITIES;
export const isRelatedAttr = (attribute: catalog.IAttribute) =>
  isRelatedEntitiesAttr(attribute) || isRelatedEntityAttr(attribute);
